import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { unarchiveCheckTypesFailed, unarchiveCheckTypesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* unarchiveCheckTypes(action) {
  try {
    if (!action.payload) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/registries/check-types/unarchive/${action.payload}`;
    const response = yield makeRequest(url, {}, action, 'PUT', true);
    if (response.status === OK) {
      yield put(unarchiveCheckTypesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(unarchiveCheckTypesFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(unarchiveCheckTypesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
